module.exports = __webpack_public_path__ + "static/img/TFHJ_H5.2400252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/TFHJ_H5.png
// module id = nZSA
// module chunks = 34